import { makeExportAction } from "src/actions/makeExportAction"

export const ExportSalesAction = ({ onExport }) =>
  makeExportAction({ noun: "sale", onExport })
